import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import styles from './summary.css';

@themr('SummaryTheme', styles)
class Summary extends Component {
  render() {
    const { theme, onClick, data } = this.props;
    return(
      <div onClick={onClick ? onClick : null} className={theme.summaryContent} dangerouslySetInnerHTML={{ __html: data }} />
    );
  }
}

export default Summary;



// WEBPACK FOOTER //
// ./src/components/Summary/Summary.js